var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-filter-buttons"},_vm._l((_vm.items),function(item){return _c(_setup.BCXButton,{key:item.value,attrs:{"type":"filter","active":_setup.vmValue.includes(item.value)},on:{"click":function($event){return _setup.onClick(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }